<template>
    <div v-if="loaded" >
        <div class="intro">
            {{  textArray[0] }}
                <span class="ml1 text-wrapper">
                    <span class="letters" ref="letters">{{ firstWord }}</span>
                </span>
            {{  textArray[1] }}
                <span class="ml2 text-wrapper">
                    <span class="letters" ref="letters">{{ secondWord }}</span>
                </span>
            {{  textArray[2] }}
            
        </div>
    </div>

</template>

<script>
import anime from 'animejs/lib/anime.es.js';

export default {
    name: 'VacancyIntro',
    data() {
        return {
            loaded: false,
            textArray: null,
            firstCycleIndex: 0,
            firstArray: null,
            firstWord: null,
            animateOut: false,
            animateIn: false,
            secondCycleIndex: 0,
            secondArray: null,
            secondWord: null,
            secondText: null
        };
    },
    props: ['first', 'second', 'text'],
    mounted: function() {
        this.firstArray = JSON.parse(this.first);
        this.secondArray = JSON.parse(this.second);
        this.updateFirstWord();
        this.updateSecondWord();
        this.textArray = this.text.split('%s');

        this.loaded = true;
        this.$nextTick(() => {
            this.anime();
            this.anime2();
            
        });
    },
    methods: {
        updateFirstWord() {
            this.firstWord = this.firstArray[this.firstCycleIndex];
            this.firstCycleIndex = (this.firstCycleIndex + 1) % this.firstArray.length;
        },
        updateSecondWord() {
            this.secondWord = this.secondArray[this.secondCycleIndex];
            this.secondCycleIndex = (this.secondCycleIndex + 1) % this.secondArray.length;
        },
        anime() {
            let textWrapper = this.$el.querySelector('.ml1 .letters');
            textWrapper.innerHTML = this.firstWord.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");

            let tl = anime.timeline({
                loop: false,
                delay: 2000,
                complete: () => {
                    tl.seek(0);
                    tl.pause();
                    
                    this.updateFirstWord();
                    
                    textWrapper.innerHTML = '';
                    tl = null;

                    this.anime();
                }
            })
            .add({
                targets: '.ml1 .letter',
                opacity: [0,1],
                maxWidth: ['0px','100px'],
                easing: "easeOutCirc",
                duration: 800,
                offset: '-=775',
                delay: (el, i) => 34 * (i+1)
            }).add({
                targets: '.ml1 .letter',
                opacity: [1,0],
                maxWidth: ['100px','0px'],
                easing: "easeInCirc",
                duration: 100,
                offset: '-=775',
                delay: (el, i) => 3000 + 34 * (i+1)
            });
        },
        anime2() {
            let textWrapper = this.$el.querySelector('.ml2 .letters');
            textWrapper.innerHTML = this.secondWord.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");

            let tl = anime.timeline({
                loop: false,
                complete: () => {
                    tl.seek(0);
                    tl.pause();
                    
                    this.updateSecondWord();
                    
                    textWrapper.innerHTML = '';
                    tl = null;

                    this.anime2();
                }
            })
            .add({
                targets: '.ml2 .letter',
                opacity: [0,1],
                maxWidth: ['0px','100px'],
                easing: "easeOutCirc",
                duration: 800,
                offset: '-=775',
                delay: (el, i) => 34 * (i+1)
            }).add({
                targets: '.ml2 .letter',
                opacity: [1,0],
                maxWidth: ['100px','0px'],
                easing: "easeInCirc",
                duration: 100,
                offset: '-=775',
                delay: (el, i) => 3000 + 34 * (i+1)
            });
        }
    }
};
</script>
